'use client';
import { ApolloProvider } from '@apollo/client';
import { appPublicConfig } from '@/configs/appPublicConfig';
import persistedQueryManifest from '@/gql/__codegen__/persisted-query-manifest.json';
import { TapiContext } from '@/shared/hooks/useTapiFetcher';
import { initApollo } from '@/shared/libs/apollo/initApollo';

const apolloClient = initApollo(
  appPublicConfig,
  'stargate_cinemacoupon',
  persistedQueryManifest
);

export const GlobalProviders: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <ApolloProvider client={apolloClient}>
    <TapiContext.Provider value={appPublicConfig.TAPI_ENDPOINT}>
      {children}
    </TapiContext.Provider>
  </ApolloProvider>
);
